/**
 * Patient Create Page
 *
 *
 * This page renders a breadcrumb navigation and the PatientCreateForm component.
 *
 *
 * The orderId param is optional and is used to determine if the order is being created or edited.
 */
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import PatientPayorForm from "./-patient-payor-form";
import { createFileRoute, Link, useNavigate } from "@tanstack/react-router";
import { Button } from "@/components/ui/button";
import { PatientCrumbs } from "../../-crumbs";

export const Route = createFileRoute(
  "/_private/_patient-360/patient/$patientId/create/patient-payor",
)({
  component: PatientPayorCreatePage,
});

function PatientPayorCreatePage() {
  const { patientId } = Route.useParams();
  const navigate = useNavigate();

  const onSuccessFn = () => {
    navigate({
      to: "/patient/$patientId/create/payment",
      params: { patientId },
    });
  };

  return (
    <div>
      <title>Patient Payor - Legrande Health Portal</title>
      <PatientCrumbs />

      <Card>
        <CardHeader>
          <CardTitle>New Patient Payor</CardTitle>
          <CardDescription>Enter patient payor details below.</CardDescription>
        </CardHeader>
        <CardContent>
          <PatientPayorForm
            patientId={patientId}
            onSuccessFn={onSuccessFn}
            onCancelBtn={
              <Button variant="outline" asChild>
                <Link
                  to="/patient/$patientId/create/payment"
                  params={{ patientId }}
                >
                  Skip
                </Link>
              </Button>
            }
          />
        </CardContent>
      </Card>
    </div>
  );
}
